import React, { useState, useEffect } from "react";
import "./style.scss";
import SignModal from "./SignModal";

const Signature = (props) => {
  const {
    acknowledgeShow,
    signatureObj,
    eSign,
    signatureError,
    setSignatureError,
    summaryPage,
    valueObject,
    employeePdf,
  } = props;
  const [uploadSignShowModal, setUploadSignShowModal] = useState(false);
  const [showUploadedImage, setShowUploadedImage] = useState(null);
  const [signObject, setSignObject] = useState({
    uploadSign: "",
    drawSign: eSign,
  });

  useEffect(() => {
    setSignObject({ drawSign: eSign, uploadSign: "" });
  }, [eSign]);
  useEffect(() => {
    if (valueObject) {
      setSignObject({ drawSign: valueObject, uploadSign: "" });
    }
  }, [valueObject]);
  //upload sign
  const uploadSignClick = () => {
    document.body.classList.add("upload-modal-open");
    setUploadSignShowModal(true);
  };

  const uploadSignModalClose = () => {
    document.body.classList.remove("upload-modal-open");
    setUploadSignShowModal(false);
  };

  const getSignature = (data) => {
    setShowUploadedImage(data?.uploadSign[0]);
    setSignObject(data);
    if (data?.drawSign !== "" || data?.uploadSign !== "") {
      acknowledgeShow(false);
    }
    signatureObj(data);
  };

  return (
    <>
      {(signObject?.drawSign === "" && signObject?.uploadSign === "") ||
      signObject?.drawSign === undefined ? (
        <div
          className="sign-box"
          onClick={summaryPage ? null : uploadSignClick}
        >
          <div className="title">Click to add Signature</div>
          <div className="sub-title mt-2">
            Draw or upload signature to complete
          </div>
        </div>
      ) : (
        ""
      )}

      {signObject?.drawSign !== "" && signObject?.drawSign !== undefined ? (
        (() => {
          // Check if we have valid image data
          let hasValidImage = false;
          let imageSrc = null;
          
          if (employeePdf) {
            if (typeof signObject?.drawSign === 'string') {
              if (signObject?.drawSign.startsWith('{')) {
                try {
                  const parsed = JSON.parse(signObject?.drawSign);
                  imageSrc = parsed?.signature;
                } catch (e) {
                  imageSrc = null;
                }
              } else {
                imageSrc = signObject?.drawSign;
              }
            } else {
              imageSrc = signObject?.drawSign?.signature;
            }
          } else {
            imageSrc = signObject?.drawSign;
          }
          
          // Check if imageSrc is a valid data URL
          hasValidImage = imageSrc && imageSrc.startsWith('data:image/');
          
          if (hasValidImage) {
            return (
              <>
                {summaryPage ? null : (
                  <div className="text-end clear-sign mb-2" onClick={uploadSignClick}>
                    Edit Signature
                  </div>
                )}
                <div className="e-sign-box mb-3">
                  <img
                    src={imageSrc}
                    alt="sign1"
                    className="upload-e-sign"
                  />
                </div>
              </>
            );
          } else {
            // No valid image, show signature modal trigger
            return (
              <div
                className="sign-box"
                onClick={summaryPage ? null : uploadSignClick}
              >
                <div className="title">Click to add Signature</div>
                <div className="sub-title mt-2">
                  Draw or upload signature to complete
                </div>
              </div>
            );
          }
        })()
      ) : signObject?.uploadSign !== "" ? (
        <>
          <div className="text-end clear-sign mb-2" onClick={uploadSignClick}>
            Edit Signature
          </div>
          <div className="e-sign-box mb-3">
            <img
              src={window.URL.createObjectURL(showUploadedImage)}
              alt="sign"
              className="upload-e-sign"
            />
          </div>
        </>
      ) : (
        ""
      )}
      {signatureError !== "" ? (
        <div className="text-error">
          <p>{signatureError}</p>
        </div>
      ) : null}
      {uploadSignShowModal && (
        <SignModal
          show={uploadSignShowModal}
          handleClose={uploadSignModalClose}
          getSignature={getSignature}
          setSignatureError={setSignatureError}
        />
      )}
    </>
  );
};

export default Signature;
